const key = "add-entity-filter";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/12$/);
};

const ruleJson = {
	"Id": 1,
	"Title": "Fisherman classified 11 only allows vessel MS4321",
	"Operator":
	{
		"Id": 2,
		"Code": "OR",
		"Name": "Or"
	},
	"Children":
	[
		{
			"Id": 1,
			"Operator":
			{
				"Id": 2,
				"Code": "OR",
				"Name": "Or"
			},
			"Engine":
			{
				"Id": 2,
				"Code": "CLASSIFICATION",
				"Name": "Classification"
			},
			"Conditions":
			[
				{
					"Id": 1,
					"Field":
					{
						"Id": 905
					},
					"Operator":
					{
						"Id": 7,
						"Code": "ISNOT",
						"Name": "Classification : Is Not Classified As"
					},
					"Value": "55"
				}
			]
		},
		{
			"Id": 2,
			"Operator":
			{
				"Id": 2,
				"Code": "OR",
				"Name": "Or"
			},
			"Engine":
			{
				"Id": 2,
				"Code": "COMPARE",
				"Name": "Compare"
			},
			"Conditions":
			[
				{
					"Id": 3,
					"Field":
					{
						"Id": 921
					},
					"Operator":
					{
						"Id": 99,
						"Code": "EQUALTO",
						"Name": "Equal To"
					},
					"Value": "MS4321"
				}
			]
		}
	],
	"Triggers":
	[
		{
			"Field":
			{
				"Id": 921
			},
			"Operator":
			{
				"Id": 13,
				"Code": "FILTER",
				"Name": "Filter"
			},
			"Type":
			{
				"Id": 2,
				"Code": "USERINTERFACE",
				"Name": "User Interface"
			}
		}
	],
	"Scope":
	{
		"Code": "REPORT"
	}
};

const modify = (resp) => {
	if(!resp.data.Data?.Rules) {
		return;
	}

	resp.data.Data.Rules.push(ruleJson);
};

export const addEntityFilter = [key, applicable, modify];